<template>
  <div class="vue-wrapper-sidebar" id="contract-notes">
    <div class="modal-window-header">
      <div class="modal-window-heading">
        <h3>Objektnotater</h3>
      </div>
    </div>

    <overlay-scrollbars v-if="!loading && items.length > 0" :options="{ className: 'modal-window-body gray os-theme-dark', scrollbars: { visibility: 'auto', autoHide: 'leave', autoHideDelay: 400, dragScrolling: true, clickScrolling: false, touchSupport: true, snapHandle: false } }">
      <div class="messages-container" v-if="!loading && items.length > 0">
        <div class="message" v-for="item in filteredItems" v-bind:key="item.id">
          <div class="message-avatar">
            <span class="avatar name right" :class="strToAvatarClass(item.bruker.initials)" v-if="item.bruker">
              {{item.bruker.initials}}
              <span class="name">{{item.bruker.full_name}}</span>
            </span>
            <!-- Fallback to registret-av if no bruker found -->
            <span class="avatar name right" :class="strToAvatarClass('-')" v-else>
              {{item.Registrert_av}}
              <span class="name">{{item.Registrert_av}}</span>
            </span>
          </div>
          <div class="message-content">
            <p>
              {{item.Notat}}
              <span v-if="item.SentToAccounting"><br><br><em>Sendt til regnskap: {{item.SentToAccounting | avantidatenice}}</em></span>
            </p>

            <div class="message-timestamp"><time>{{item.Registrert_tid | avantidatenice}}</time></div>
          </div>
        </div>

        <div class="message" v-if="items.length > 0">
          <div style="width: 100%; text-align: center; margin-top: 10px" v-if="!everythingLoaded && pageCount > 1">
            <button href="javascript:;" @click="loadMore()" class="button secondary action glyph" v-if="!loading && !updating">
              <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-add"></use></svg>
              <span>Last fler</span>
            </button>
            <button href="javascript:;" class="button secondary action glyph loading" v-else>
              <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-add"></use></svg>
              <span>Laster fler <span class="loader-spinner"></span></span>
            </button>
          </div>
          <div style="width: 100%; text-align: center; margin-top: 10px; font-size: 0.8em" v-else>
            Alt har blitt lastet inn
          </div>
        </div>
      </div>
    </overlay-scrollbars>

    <div class="modal-window-body gray" v-else>
      <TheLoader :active="loading"/>
      <TheEmptyList v-if="!loading && (items.length < 1 && !objekt.Merknad)" :title="'Ingen objektnotater'" :message="'Objektnotater kan brukes som interne merknader som ikke er synlig for kunden.'" :large="false" :icon="'button-glyph-comment'"/>
    </div>

    <!-- <div class="grid-x toolbar footer"></div> -->

    <a href="javascript:;" @click="$emit('close')" class="modal-close modal-window-close-button"><span>Lukk</span> <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-close"></use></svg></a>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'TilslagsskjermbildeSidebarNotesModal',
  props: {
    objekt: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      currentPage: 1, // Just for the pagination component
      search: '',
      searchBoxActive: false
    }
  },
  created () {
    this.setFormLoading(false)

    // Not in use, as we removed paging
    this.currentPage = this.queryParams.page || 1

    // Debounced input
    this.onSearchInput = this._.debounce(this.onSearchInput, 500)
  },
  computed: {
    ...mapGetters('objektnotat', [
      'items',
      'pageCount',
      'totalCount',
      'everythingLoaded',
      'queryParams',
      'loading',
      'updating'
    ]),
    filteredItems: function () {
      if (!this.search) {
        return this.items
      }

      return this.items.filter((i) => {
        return this._.includes(this._.toLower(i.Notat), this.search)
      })
    }
  },
  methods: {
    clearSearch: function () {
      this.search = ''
      this.toggleSearchbox(false)
    },
    toggleSearchbox: function (mode) {
      if (mode === false) {
        this.searchBoxActive = this.search !== ''
      } else {
        this.searchBoxActive = true
      }
    },
    onSearchInput: function (e) {
      // In it's own method, so we can have debounce
      this.search = this._.toLower(e.target.value.trim())
    },
    loadMore: function () {
      let page = this.currentPage + 1

      if (page > this.pageCount) {
        console.log('Last page already loaded')
        return
      }

      // Make query to load more...
      let copiedParams = this._.clone(this.queryParams)
      this.currentPage = page
      copiedParams.page = this.currentPage

      this.$store.dispatch('objektnotat/reload', {
        Kundenr: this.objekt.Innlevav,
        Kontraktnr: this.objekt.Kontraktnr,
        Objektid: this.objekt.Objektid,
        queryParams: copiedParams
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/Auctions/Tilslagsskjermbilde/TilslagsskjermbildeSidebarNotesModal.vue